import type { DemandeCreateDTO } from '@/features/api/extranet/dto/Demande/shared'
import type { DossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese'
import { useFavorisStore } from '@/features/interface/favoris/favorisStore'
import apiDemande from '@/features/services/demande/DemandeAllService'
import { navigateTo, type NavigateToDemande, type ToDispositif } from '@/router/navigateTo'
import { useAjouteDemandeTT } from '@/features/interface/demande/ajouter-tt'

export function useRechercheDossierTtActions() {
  const { addFavori } = useFavorisStore()

  function displayDossier(code: string) {
    return navigateTo({ to: 'detail', domaine: 'tt', module: 'dossier', code: code })
  }

  async function addDemande() {
    try {
      const storeAddDemande = useAjouteDemandeTT()
      const demande = await storeAddDemande.showAjoute()
      navigateTo({
        to: 'detail',
        domaine: 'tt',
        module: 'demande',
        dispositif: demande.dispositif.toLowerCase() as ToDispositif,
        sousDispositif: 'sousDispositif' in demande ? demande.sousDispositif : null,
        id: demande.id,
      } as NavigateToDemande)
    } catch (err) {
      console.error(err)
    }
  }

  async function addDemandeDR(item: DossierDTO) {
    if (item.niveauPermissionDr !== 'Ecriture')
      throw new Error("Le dossier n'est pas éligible à la DR ou habilitations insuffisantes.")

    const result = await apiDemande.addDemande({
      typeDemande: 'Remboursement',
      dispositif: item.dispositif,
      sousDispositif: item.sousDispositif,
      siret: item.etablissementAdherentPrincipal?.siret,
      typePublic: item.typePublic,
      consentementTraitementDonnees: true,
      codeDossier: item.code,
    } as DemandeCreateDTO)

    navigateTo({
      to: 'detail',
      domaine: 'dr',
      module: 'demande',
      id: result.id,
    })
  }

  return { displayDossier, addFavori, addDemande, addDemandeDR }
}
